/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

/**
 * @nullable
 */
export type NsureClientCaseStateCaseStatus = (typeof NsureClientCaseStateCaseStatus)[keyof typeof NsureClientCaseStateCaseStatus] | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NsureClientCaseStateCaseStatus = {
  New: "New",
  InProgress: "InProgress",
  InSignature: "InSignature",
  Signed: "Signed",
  Rejected: "Rejected",
  Done: "Done",
  Error: "Error",
  Cancelled: "Cancelled",
} as const;
